import React from "react";
import { Glyphicon as GlyphiconRB } from "react-bootstrap";
import tooltip from "../../../MapStore2/web/client/components/misc/enhancers/tooltip";

const Glyphicon = tooltip(GlyphiconRB);

interface GlyphButtonProps {
    id: string;
    itemId: string | number;
    boolParameter?: boolean;
    glyph: string;
    onClick: Function | null;
    className: string;
    tooltip: string;
}

const GlyphButton = (props: GlyphButtonProps) => {
    return props.onClick ? (
        <div
            id={props.id}
            className={props.className}
            onClick={() => props.onClick!(props.itemId, !props.boolParameter)}
        >
            <Glyphicon
                className={"text-primary"}
                glyph={props.glyph}
                tooltip={props.tooltip}
                tooltipPosition={"bottom"}
            />
        </div>
    ) : null;
};

export default GlyphButton;
